export const promiseWithResolver = <T>() => {
  let resolve: (value: T | undefined) => void = () => {};
  let reject: (reason?: Error) => void = () => {};

  const promise = new Promise<T | undefined>((res, rej) => {
    resolve = res;
    reject = rej;
  });

  return {promise, resolve, reject};
};
